import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const PlatformLifecycleContext = createContext(undefined);
export const PlatformLifecycleProvider = ({ value, children }) => (_jsx(PlatformLifecycleContext.Provider, { value: value, children: children }));
export function usePlatformLifecycle() {
    const ctx = useContext(PlatformLifecycleContext);
    if (!ctx) {
        throw new Error("usePlatformLifecycle must be used within a PlatformLifecycleProvider");
    }
    return ctx;
}
/**
 * Thin wrapper so call sites expose a single top-level hook name
 * (`usePlatformIsActive`) to `react-hooks/rules-of-hooks`, rather than the
 * chained `usePlatformLifecycle().useIsActive()` form which the linter can't
 * trace through.
 */
export function usePlatformIsActive() {
    return usePlatformLifecycle().useIsActive();
}
